//3rd Party Components
import { createSelector } from 'reselect';

const orgdetailsSelector = (state, key) => (state.organisationDetails?.items?.value?.length > 0) ? state.organisationDetails.items.value[0][key] : null;

export const getOrgDetailsSelector = createSelector(
    orgdetailsSelector,
    (value) => value
);
